<template>

<div>

  <router-link :to="href" v-html="text"></router-link>

</div>

</template>

<script>
export default {
  name: 'Link',
  props: {
    text: String,
    href: String
  }
}
</script>

<style lang="scss" scoped>
</style>
